import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
// import ReportHeading from '@/Utils/report-head'
// import { dateFormat } from '@/Utils/fliter'

function getCurricularTypeName (type, indx) {
  let myRow = ''
  if (indx === 0) {
    myRow = { text: i18n.locale === 'bn' ? type.type_name_bn : type.type_name, style: 'td', rowSpan: type.activities.length, alignment: 'center' }
  }
  return myRow
}

function getRemarks (remarks) {
  let remark = ''
  if (remarks === 'v_good') {
    remark = i18n.locale === 'en' ? 'Very good' : 'খুব ভাল'
  } else if (remarks === 'good') {
    remark = i18n.locale === 'en' ? 'Good' : 'ভাল'
  } else if (remarks === 'satis') {
    remark = i18n.locale === 'en' ? 'Satisfactory' : 'সন্তোষজনক'
  } else {
    remark = i18n.locale === 'en' ? 'Need to improve' : 'উন্নতি করতে হবে'
  }
  const myRow = { text: remark, style: 'td', alignment: 'center' }
  return myRow
}

function getGradeName (grade, avg) {
  let myRow = ''
  if (parseInt(grade.mark_from) <= parseInt(avg) && parseInt(avg) <= parseInt(grade.mark_to)) {
    myRow = { text: i18n.locale === 'bn' ? grade.text_bn : grade.text_en, style: 'td', alignment: 'center', bold: true, fillColor: '#dee2e6' }
  } else {
    myRow = { text: i18n.locale === 'bn' ? grade.text_bn : grade.text_en, style: 'td', alignment: 'center' }
  }
  return myRow
}

const exportPdfDetails = async (reportTitle, pdfData, vm) => {
    try {
        Store.commit('mutateCommonProperties', {
            loading: true
        })
        if (i18n.locale === 'bn') {
            pdfMake.vfs = pdfFontsBn.pdfMake.vfs
        } else {
            pdfMake.vfs = pdfFontsEn.pdfMake.vfs
        }
        const pdfContent = []
        pdfContent.push(
            { text: vm.$t('globalTrans.organization') + ' :' + i18n.locale === 'bn' ? pdfData.assessment.organization_name_bn : pdfData.assessment.organization_name, alignment: 'center' },
            { text: i18n.locale === 'bn' ? pdfData.assessment.institute_name_bn : pdfData.assessment.institute_name, alignment: 'center', bold: true, marginTop: 2 },
            { text: reportTitle, style: 'header', alignment: 'center', decoration: 'underline' },
            { text: vm.$t('ds_exam_management.academic_year') + ' - ' + vm.$n(pdfData.assessment.year, { useGrouping: false }), alignment: 'center' }
        )
        pdfContent.push({ text: '', marginBottom: 5 })
        const topRows = [
          [
            { text: vm.$t('ds_institute_management.student_name'), bold: true, style: 'td' },
            { text: i18n.locale === 'bn' ? pdfData.assessment.student.name_bn : pdfData.assessment.student.name_en, style: 'td', colSpan: '3' },
            {},
            {}
          ],
          [
            { text: vm.$t('ds_institute_management.class'), bold: true, style: 'td' },
            { text: i18n.locale === 'bn' ? pdfData.assessment.class_name_bn : pdfData.assessment.class_name, style: 'td', colSpan: '3' },
            {},
            {}
          ],
          [
            { text: vm.$t('ds_student_management.student_roll'), bold: true, style: 'td' },
            { text: vm.$n(pdfData.assessment.student.student_id, { useGrouping: false }), style: 'td', colSpan: '3' },
            {},
            {}
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: '25%',
            body: topRows
          }
        })
        // Curriculum Info
        if (pdfData.slotdatas.length > 0) {
          pdfData.slotdatas.map((slots) => {
            pdfContent.push({ text: vm.getSlotName(slots.iep_slot_id), style: 'my_title', decoration: 'underline', alignment: 'center' })
            const allRowsHead1 = [
              [
                { text: vm.$t('ds_student_management.skill_name'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.scheduled_work'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.previous_status'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.current_status'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.comments_evaluation'), style: 'th', alignment: 'center' }
              ]
            ]
            slots.curriculums.map((type) => {
              type.activities.forEach((item, indx) => {
                allRowsHead1.push([
                  getCurricularTypeName(type, indx),
                  { text: i18n.locale === 'bn' ? item.activity_name_bn : item.activity_name, style: 'td', alignment: 'center' },
                  { text: vm.$n(item.average_marks, { useGrouping: false }), style: 'td', alignment: 'center' },
                  { text: vm.$n(item.marks, { useGrouping: false }), style: 'td', alignment: 'center' },
                  getRemarks(item.remarks)
                ])
              })
            })
            pdfContent.push({
              table: {
                headerRows: 1,
                widths: ['*', '*', '*', '*', '*'],
                body: allRowsHead1
              }
            })
          })
        }
        // Course Info
        pdfContent.push({ text: vm.$t('ds_exam_management.result'), style: 'title_header', alignment: 'center', decoration: 'underline' })
        if (pdfData.coursesData.length > 0) {
          pdfData.coursesData.map((slots) => {
            pdfContent.push({ text: vm.getSlotName(slots.iep_slot_id), style: 'my_title', decoration: 'underline', alignment: 'center' })
            const allRowsHead1 = [
              [
                { text: vm.$t('ds_exam_management.course_sub_name'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_config.total_mark'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_config.pass_mark'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.obtained_marks'), style: 'th', alignment: 'center' }
              ]
            ]
            slots.details.forEach((course, indx) => {
              allRowsHead1.push([
                { text: vm.getCourseName(course.course_id), style: 'td', alignment: 'center' },
                { text: vm.$n(course.total_marks, { useGrouping: false }), style: 'td', alignment: 'center' },
                { text: vm.$n(course.pass_marks, { useGrouping: false }), style: 'td', alignment: 'center' },
                { text: vm.$n(course.obtain_marks, { useGrouping: false }), style: 'td', alignment: 'center' }
              ])
            })
            pdfContent.push({
              table: {
                headerRows: 1,
                widths: ['*', '*', '*', '*'],
                body: allRowsHead1
              }
            })
          })
        }
        // Home work evaluation
        pdfContent.push({ text: vm.$t('ds_exam_management.homework_evaluation'), style: 'title_header', alignment: 'center', decoration: 'underline' })
        if (pdfData.homeworkData.length > 0) {
          pdfData.homeworkData.map((slots) => {
            pdfContent.push({ text: vm.getSlotName(slots.iep_slot_id), style: 'my_title', decoration: 'underline', alignment: 'center' })
            const allRowsHead1 = [
              [
                { text: vm.$t('home_work.subject'), style: 'th', alignment: 'center' },
                { text: vm.$t('globalTrans.status'), style: 'th', alignment: 'center' },
                { text: vm.$t('ds_student_management.comments_evaluation'), style: 'th', alignment: 'center' }
              ]
            ]
            slots.details.forEach((home, indx) => {
              allRowsHead1.push([
                { text: vm.getObservationName(home.observation_type), style: 'td', alignment: 'left' },
                { text: vm.getOption.find(itm => itm.value === home.is_regular).text, style: 'td', alignment: 'center' },
                { text: vm.getOption2.find(itm => itm.value === home.is_satisfied).text, style: 'td', alignment: 'center' }
              ])
            })
            pdfContent.push({
              table: {
                headerRows: 1,
                widths: ['*', '*', '*'],
                body: allRowsHead1
              }
            })
          })
        }
        // Efficiency Assessment
        pdfContent.push({ text: vm.$t('ds_exam_management.efficiency_assessment'), style: 'title_header', alignment: 'center', decoration: 'underline' })
        if (pdfData.slotdatas.length > 0) {
          pdfData.slotdatas.map((slots) => {
            pdfContent.push({ text: vm.getSlotName(slots.iep_slot_id), style: 'my_title', decoration: 'underline', alignment: 'center' })
            if (vm.gradeList.length > 0) {
              const allRowsHead1 = []
              vm.gradeList.forEach((grade, indx) => {
                allRowsHead1.push([
                  getGradeName(grade, slots.avg),
                  { text: i18n.locale === 'bn' ? grade.remarks_bn : grade.remarks_en, style: 'td', alignment: 'center' }
                ])
              })
              pdfContent.push({
                table: {
                  headerRows: 1,
                  widths: ['*', '*'],
                  body: allRowsHead1
                }
              })
            }
          })
        }
        // School Rules
        if (vm.schoolRulesList.length > 0) {
          pdfContent.push({ text: vm.$t('ds_exam_management.school_rules'), style: 'title_header', marginBottom: 10, alignment: 'center', decoration: 'underline' })
          const allRowsHead1 = []
          vm.schoolRulesList.forEach((rules, indx) => {
            allRowsHead1.push([
              { text: '* ' + rules.text + '\n', alignment: 'left', style: 'td' }
            ])
          })
          pdfContent.push(allRowsHead1)
        }

        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portrait',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
              th: {
                fillColor: '#dee2e6',
                fontSize: 10,
                margin: [3, 2, 3, 2]
              },
              mytd: {
                fillColor: '#dee2e6',
                fontSize: 11,
                margin: [3, 2, 3, 2]
              },
              mytd2: {
                fillColor: '#dee2e6',
                fontSize: 12,
                margin: [3, 2, 3, 2]
              },
              td: {
                fontSize: 10,
                margin: [3, 2, 3, 2]
              },
              identity: {
                margin: [0, 5, 0, 3],
                fontSize: 12,
                alignment: 'center'
              },
              left_header: {
                margin: [4, 0, 0, 10]
              },
              header: {
                margin: [0, 10, 0, 10],
                fontSize: 14,
                alignment: 'center'
              },
              header2: {
                border: 0,
                fontSize: 14,
                margin: [0, 0, 0, 1]
              },
              title_header: {
                margin: [0, 10, 0, 0],
                fontSize: 14,
                alignment: 'center'
              },
              my_title: {
                border: 0,
                fillColor: '#dee2e6',
                fontSize: 12,
                margin: [0, 10, 0, 10]
              },
              govt_info: {
                margin: [0, 1, 0, 1],
                fontSize: 15,
                alignment: 'center'
              },
              address: {
                  border: 0,
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 0, 1]
              },
              address2: {
                border: 0,
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 1]
              },
              left_logo: {
                border: 0,
                margin: [5, 0, 0, 5]
              }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print() // 'assessment')
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
